import React from 'react';
import { AlertCircle } from 'lucide-react';

const UrgencyBanner = () => {
  return (
    <div className="bg-orange-500 overflow-hidden">
      <div className="flex animate-marquee whitespace-nowrap py-3">
        <div className="flex items-center gap-4 mx-4">
          <AlertCircle className="w-4 h-4" />
          <span className="font-mono text-sm font-bold uppercase tracking-widest">
            BENGALURU LPG SHORTAGE ALERT: 45 DAY WAITLIST
          </span>
        </div>
        <div className="flex items-center gap-4 mx-4">
          <span className="font-mono text-sm font-bold uppercase tracking-widest">
            GET BRIQUETTES TODAY - SAME DAY DELIVERY
          </span>
        </div>
        <div className="flex items-center gap-4 mx-4">
          <AlertCircle className="w-4 h-4" />
          <span className="font-mono text-sm font-bold uppercase tracking-widest">
            BENGALURU LPG SHORTAGE ALERT: 45 DAY WAITLIST
          </span>
        </div>
        <div className="flex items-center gap-4 mx-4">
          <span className="font-mono text-sm font-bold uppercase tracking-widest">
            GET BRIQUETTES TODAY - SAME DAY DELIVERY
          </span>
        </div>
      </div>
    </div>
  );
};

export default UrgencyBanner;
